import React, { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { v4 as uuid } from "uuid";
import ProjectColumn from "./ProjectColumn";
import AddProjectModal from "../../modals/kanban/AddProjectModal";
import EditProjectModal from "../../modals/kanban/EditProjectModal";
import DeleteModal from "../../modals/kanban/DeleteModal";
// import ProjectColumn from "./ProjectColumn";
// import AddProjectModal from "./AddProjectModal";
// import EditProjectModal from "./EditProjectModal";
// import DeleteModal from "./DeleteModal";
import { Button, Dropdown } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { FiCalendar } from "react-icons/fi";

const initialProjects = [
  {
    id: uuid(),
    title: "Project Title",
    code: "PRJ-154",
    priority: "Low",
    status: "New",
    budget: 24000,
    tasks: "12/15",
    due: "15 Apr 2024",
  },
  {
    id: uuid(),
    title: "Project Title",
    code: "PRJ-155",
    priority: "High",
    status: "New",
    budget: 24000,
    tasks: "12/15",
    due: "15 Apr 2024",
  },
  {
    id: uuid(),
    title: "Project Title",
    code: "PRJ-156",
    priority: "High",
    status: "Inprogress",
    budget: 24000,
    tasks: "12/15",
    due: "15 Apr 2024",
  },
  {
    id: uuid(),
    title: "Project Title",
    code: "PRJ-159",
    priority: "Low",
    status: "On-hold",
    budget: 24000,
    tasks: "12/15",
    due: "15 Apr 2024",
  },
  {
    id: uuid(),
    title: "Project Title",
    code: "PRJ-161",
    priority: "Medium",
    status: "Completed",
    budget: 24000,
    tasks: "12/15",
    due: "15 Apr 2024",
  },
];

export default function ProjectBoard() {
  const [projects, setProjects] = useState(initialProjects);
  const [search, setSearch] = useState("");

  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const [selected, setSelected] = useState(null);
  const [priority, setPriority] = useState("All");
  const [client, setClient] = useState("Clients");
  const [status, setStatus] = useState("Select Status");
  const [sort, setSort] = useState("Created Date");

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const filteredProjects = projects.filter((p) => {
    const matchPriority = priority === "All" || p.priority === priority;

    const matchSearch = p.title.toLowerCase().includes(search.toLowerCase());

    return matchPriority && matchSearch;
  });

  const addProject = (project) => {
    setProjects([...projects, { ...project, id: uuid() }]);
  };

  const updateProject = (project) => {
    setProjects(projects.map((p) => (p.id === project.id ? project : p)));
  };

  const deleteProject = () => {
    setProjects(projects.filter((p) => p.id !== selected.id));
    setShowDelete(false);
  };

  return (
    <div
      style={{ backgroundColor: "rgb(255 255 255)" }}
      className="card-project"
    >
      <div
        style={{ backgroundColor: "rgb(255 255 255)" }}
        className="card-header project-board-header"
      >
        {/* LEFT TITLE */}
        <h4 className="project-board-title">Projects</h4>

        {/* RIGHT SIDE */}
        <div className="project-header-right">
          {/* Avatars + Stats */}
          <div className="task-summary">
            <div className="avatar-group">
              <img src="https://i.pravatar.cc/30?img=1" alt="" />
              <img src="https://i.pravatar.cc/30?img=2" alt="" />
              <img src="https://i.pravatar.cc/30?img=3" alt="" />
              <div className="avatar-more">+1+</div>
            </div>

            <div className="task-stats">
              <div className="stat">
                Total Task : <span>55</span>
              </div>

              <div className="divider"></div>

              <div className="stat">
                Pending : <span>15</span>
              </div>

              <div className="divider"></div>

              <div className="stat">
                Completed : <span>40</span>
              </div>
            </div>
          </div>

          {/* SEARCH (UNCHANGED) */}
          <Form.Control
            className="project-search-input"
            style={{ width: 250 }}
            placeholder="Search Project"
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>
      {/* <div className="section-divider"></div> */}

      <div className="card-body mt-3 rounded rounded-1 ">
        {/* Priority Filter */}
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          {/* Priority */}
          <div className="d-flex align-items-center priorit-section">
            <span className="me-3 fw-semibold">Priority</span>

            <div className="priority-tabs">
              {["All", "High", "Medium", "Low"].map((p) => (
                <button
                  key={p}
                  className={`priority-btn ${priority === p ? "active" : ""}`}
                  onClick={() => setPriority(p)}
                >
                  {p}
                </button>
              ))}
            </div>
          </div>

          {/* Filters */}
          <div className="d-flex align-items-center flex-wrap gap-2">
            {/* Clients */}
            <Dropdown>
              <Dropdown.Toggle className="filter-btn">{client}</Dropdown.Toggle>

              <Dropdown.Menu className="filter-menu">
                {["Clients", "Sophie", "Cameron", "Doris"].map((c) => (
                  <Dropdown.Item key={c} onClick={() => setClient(c)}>
                    {c}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            {/* Created Date */}
            <div className="date-box">
              <FiCalendar className="calendar-icon" />

              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                dateFormat="dd-MM-yyyy"
                className="date-input"
              />
            </div>

            {/* Due Date */}
            <div className="date-box">
              <FiCalendar className="calendar-icon" />

              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                dateFormat="dd-MM-yyyy"
                className="date-input"
              />
            </div>

            {/* Status */}
            <Dropdown>
              <Dropdown.Toggle className="filter-btn text-dark">
                {status}
              </Dropdown.Toggle>

              <Dropdown.Menu className="filter-menu">
                {["Inprogress", "On-hold", "Completed"].map((s) => (
                  <Dropdown.Item key={s} onClick={() => setStatus(s)}>
                    {s}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            {/* Sort */}
            <Dropdown>
              <Dropdown.Toggle className="filter-btn">
                Sort By : {sort}
              </Dropdown.Toggle>

              <Dropdown.Menu className="filter-menu">
                {["Created Date", "Last 7 Days", "Due Date"].map((s) => (
                  <Dropdown.Item key={s} onClick={() => setSort(s)}>
                    {s}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        <Row  >
          {["New", "Inprogress", "On-hold", "Completed"].map((status) => (
            <Col className="rounded rounded-1"
              style={{ backgroundColor: "rgb(255 255 255)" }}
              lg={3}
              md={6}
              key={status}
            >
              <ProjectColumn
                title={status}
                projects={filteredProjects.filter((p) => p.status === status)}
                onAdd={() => setShowAdd(true)}
                onEdit={(p) => {
                  setSelected(p);
                  setShowEdit(true);
                }}
                onDelete={(p) => {
                  setSelected(p);
                  setShowDelete(true);
                }}
              />
            </Col>
          ))}
        </Row>
      </div>

      <AddProjectModal
        show={showAdd}
        handleClose={() => setShowAdd(false)}
        addProject={addProject}
      />

      <EditProjectModal
        show={showEdit}
        handleClose={() => setShowEdit(false)}
        project={selected}
        updateProject={updateProject}
      />

      <DeleteModal
        show={showDelete}
        handleClose={() => setShowDelete(false)}
        confirmDelete={deleteProject}
      />
      <style>{`
.card-project{
border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;
box-shadow:0 2px 5px rgba(0,0,0,0.05);
padding:15px;

}
.inbox-container{
height:100vh;
display:flex;
flex-direction:column;
}

.email-scroll-area{
flex:1;
overflow-y:auto;
}

.email-scroll-area::-webkit-scrollbar{
width:6px;
}

.email-scroll-area::-webkit-scrollbar-thumb{
background:#ccc;
border-radius:10px;
}

.dropdown-toggle::after {
display:none !important;
}

.form-check-input:checked {
background-color:#f26522;
border-color:#f26522;
}

.dropdown-item:hover {
background-color:#f26522;
color:#fff;
}
.priority-tabs{
display:flex;
background:#f3f4f6;
padding:4px;
border-radius:10px;
}

.priority-btn{
border:none;
background:transparent;
padding:6px 14px;
border-radius:8px;
font-size:14px;
color:#555;
}

.priority-btn.active{
background:white;
color:#ff6a00;
font-weight:500;
box-shadow:0 2px 4px rgba(0,0,0,0.1);
}
.project-board-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px;
  border-bottom: 1px solid #dee2e6;
}

/* Title */
.project-board-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

/* Right section */
.project-header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* Avatar group */
.avatar-group {
  display: flex;
  align-items: center;
}

.avatar-group img,
.avatar-more {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #fff;
  margin-left: -8px;
  object-fit: cover;
}

.avatar-group img:first-child {
  margin-left: 0;
}

.avatar-more {
  background: #f97316;
  color: #fff;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
}

/* Stats */
.task-summary {
  display: flex;
  align-items: center;
  gap: 14px;
}

.task-stats {
  display: flex;
  align-items: center;
  gap: 14px;
}

.stat {
  font-size: 14px;
  color: #6b7280;
}

.stat span {
  font-weight: 600;
  color: #111827;
}

/* Divider */
.divider {
  width: 1px;
  height: 18px;
  background: #dee2e6;
}

/* 📱 Mobile */
@media (max-width: 768px) {
  .project-header-right {
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .task-summary {
    width: 100%;
    justify-content: space-between;
  }

  .divider {
    display: none;
  }
}
/* filter buttons */

.filter-btn{
background:white !important;
border:1px solid #ddd !important;
color:#333 !important;
padding:6px 14px !important;
border-radius:8px !important;
font-size:14px;
}

.filter-menu{
border-radius:10px;
padding:10px;
border:none;
box-shadow:0 4px 15px rgba(0,0,0,0.1);
}

/* date picker */

.date-box{
position:relative;
display:flex;
align-items:center;
border:1px solid #ddd;
border-radius:8px;
padding:5px 10px;
background:white;
}

.calendar-icon{
margin-right:6px;
color:#555;
}

.date-input{
border:none;
outline:none;
width:110px;
}
// .section-divider {
//   width: 100%;
//   height: 1px;
//   background-color: #e5e7eb; /* light grey */
//   margin: 16px 0; /* space top & bottom */
// }
/* calendar selected date */

.react-datepicker__day--selected{
background:#ff6a00 !important;
border-radius:6px;
}

.react-datepicker{
border-radius:10px;
border:none;
box-shadow:0 4px 15px rgba(0,0,0,0.15);
}

@media (max-width: 768px) {
  .project-board-header {
    flex-wrap: wrap;
    gap: 12px;
    align-items: stretch;
  }

  .project-header-right {
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: 12px;
    width: 100%;
  }

  .task-summary {
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
  }

  .task-stats {
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-start;
    width: 100%;
  }

  .avatar-group {
    margin-bottom: 0;
  }

  .project-board-title {
    width: 100%;
    margin-bottom: 0;
  }

  .project-search-input {
    width: 100% !important;
    min-width: 0 !important;
  }

.priorit-section{
flex-wrap:wrap;

}
.priority-tabs{
margin-top:3px;

}
}
`}</style>
    </div>
  );
}
